import React, { forwardRef } from "react";
import cns from "classnames";
import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { AccountPlus } from "mdi-material-ui";

type Props = {
  label?: string;
  onClick: () => void;
  small?: boolean;
  ref?: React.Ref<typeof Chip>;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    cursor: "pointer",
    "&:hover": { backgroundColor: theme.palette.grey[400] },

    "&$small": {
      height: 24
    }
  },

  small: {}
}));

export const AddRecipientChip = forwardRef((props: Props, ref) => {
  const { label = locale.AddRecipient } = props;
  const classes = useStyles({});

  return (
    <Chip
      style={{ padding: 3 }}
      className={cns(classes.root)}
      icon={<AccountPlus fontSize="small" style={{ color: "#000" }} />}
      innerRef={ref}
      onClick={props.onClick}
      label={<span style={{ marginLeft: 3 }}>{label}</span>}
    />
  );
});
